import { render } from "./SingleSelector.vue?vue&type=template&id=64fe8f40&scoped=true"
import script from "./SingleSelector.vue?vue&type=script&lang=js"
export * from "./SingleSelector.vue?vue&type=script&lang=js"

import "./SingleSelector.vue?vue&type=style&index=0&id=64fe8f40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fe8f40"]])

export default __exports__